<template>
  <div>
    <br />
    <button
      type="button"
      class="btn btn-outline-primary btn-created"
      @click="showModal()"
    >Cadastrar parceiro</button>
    <b-modal ref="my-modal" hide-footer title="Parceiro">
      <div class="d-block">
        <form @submit="checkForm">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="name">CPF/CNPJ</label>
                <the-mask
                  class="form-control form-control-alternative"
                  v-on:blur.native="findByCnpj(payload.cpfCnpj)"
                  v-model="payload.cpfCnpj"
                  :mask="['###.###.###-##', '##.###.###/####-##']"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="name">Nome ou razão social</label>
                <input type="text" class="form-control" v-model="payload.nomeParceiro" />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="name">Responsável</label>
                <input type="text" class="form-control" v-model="payload.nomeResponsavel" />
              </div>
            </div>
          </div>
          <div class="text-right">
            <button type="submit" class="btn btn-outline-primary">Salvar</button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { AdminService } from "@/http";
import { Parceiro } from "@/soganhei";


export default {
  name: "Parceiro",
  components: {},
  data: () => {
    return {
      payload: Parceiro,
      itemsServicos: [],
      buscarServicos: ""
    };
  },
  methods: {
    showModal: function() {
      this.payload = {};
      this.$refs["my-modal"].show();
    },
    visualizarParceiro(idParceiro) {
     
      AdminService.Parceiro(idParceiro)
        .then(response => {
          this.payload = response.data;
          this.$refs["my-modal"].show();
        })
        .catch(error => {
          window.console.log(error);
        });
    },
    
    findByCnpj(cpfCnpj){
         window.console.log(cpfCnpj)
    },
    checkForm(e) {
      e.preventDefault();

      const payload = Object.assign(Parceiro, this.payload);
        
      AdminService.SalvarParceiro(payload)
        .then(respose => {
          
          window.console.warn(respose.statusText);
          this.$notify({
            group: "notify",
            text: "Salvo com sucessso",
            type: "success"
          });

          this.$refs["my-modal"].hide();
          this.$emit("parceiros");
        })
        .catch(error => {
          window.console.error(error.response);
        });
    }
  }
};
</script>